/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import noTagsStyle from './no-tags.inline.styl';

export function template() {
  return (
    <div sel='.events-menu-no-tags-info'>
      <style>{noTagsStyle}</style>
      No tags in use. Learn more about
      {` `}
      <a attrs={{href: `https://docs.mixpanel.com/docs/data-governance/data-clean-up#adding-tags-to-events`}}>
        adding tags to events
      </a>
      .
    </div>
  );
}
